import styled from 'styled-components';

export const MobilePickerWrapper = styled.label<{ isHomepage: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  .CalendarMonth {
    &_caption {
      top: -25px;
      position: relative;
      padding-bottom: 0px;
    }
  }

  .DayPicker {
    border-radius: 1rem;
    padding-top: 4rem;
    width: 100%;

    position: ${({ isHomepage }) => isHomepage && 'fixed'};
    top: ${({ isHomepage }) => isHomepage && '0'};
    left: ${({ isHomepage }) => isHomepage && '0'};

    overflow: ${({ isHomepage }) => !isHomepage && 'hidden'};

    > div {
      border-top: 1px solid #eff0f1;
    }

    &_weekHeader {
      top: 60px;
    }
  }

  .CalendarMonthGrid_month__hidden {
    display: none;
  }

  .CalendarMonth_table {
    width: 100%;
  }

  .DayPicker__hidden {
    visibility: visible;
  }
  .DayPicker_transitionContainer__vertical {
    height: initial !important;
    padding-bottom: 40px;
  }
  .CalendarMonthGrid {
    width: 100% !important;
  }
`;

export const ControllerWrapper = styled.div<{ isHomepage: boolean }>`
  left: 0 !important;
  right: 0 !important;
  background: #00000094;
  display: flex;
  align-items: flex-end;
  z-index: 1;
  padding-bottom: 12rem;

  position: ${({ isHomepage }) => (isHomepage ? 'relative' : 'fixed')};
  top: ${({ isHomepage }) => (isHomepage ? '0.5rem' : '0 !important')};
  padding-top: ${({ isHomepage }) => (isHomepage ? '0' : '20vh')};

  overflow: ${({ isHomepage }) => !isHomepage && 'scroll !important'};
  bottom: ${({ isHomepage }) => !isHomepage && '-200px !important'};

  ::after {
    ${({ isHomepage }) =>
      !isHomepage &&
      `
      content: ' ';
      height: 200px;
      background: white;
      width: 100%;
      display: block;
      position: fixed;
      bottom: -200px;
    `}
  }

  .DayPicker_weekHeader {
    left: 0 !important;
    margin-left: 0 !important;
    width: 100%;
  }
  .DayPicker_weekHeader_li {
    width: calc(100% / 7) !important;
  }
`;

export const CalendarInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 20px;
`;
